/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MemberPoints model module.
 * @module model/MemberPoints
 * @version v1
 */
class MemberPoints {
    /**
     * Constructs a new <code>MemberPoints</code>.
     * @alias module:model/MemberPoints
     * @param transactionRef {String} MaxLength:35
     * @param points {Number} 
     */
    constructor(transactionRef, points) { 
        
        MemberPoints.initialize(this, transactionRef, points);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, transactionRef, points) { 
        obj['TransactionRef'] = transactionRef;
        obj['Points'] = points;
    }

    /**
     * Constructs a <code>MemberPoints</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MemberPoints} obj Optional instance to populate.
     * @return {module:model/MemberPoints} The populated <code>MemberPoints</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MemberPoints();

            if (data.hasOwnProperty('TransactionRef')) {
                obj['TransactionRef'] = ApiClient.convertToType(data['TransactionRef'], 'String');
            }
            if (data.hasOwnProperty('Points')) {
                obj['Points'] = ApiClient.convertToType(data['Points'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MemberPoints</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MemberPoints</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of MemberPoints.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['TransactionRef'] && !(typeof data['TransactionRef'] === 'string' || data['TransactionRef'] instanceof String)) {
            throw new Error("Expected the field `TransactionRef` to be a primitive type in the JSON string but got " + data['TransactionRef']);
        }

        return true;
    }


}

MemberPoints.RequiredProperties = ["TransactionRef", "Points"];

/**
 * MaxLength:35
 * @member {String} TransactionRef
 */
MemberPoints.prototype['TransactionRef'] = undefined;

/**
 * @member {Number} Points
 */
MemberPoints.prototype['Points'] = undefined;






export default MemberPoints;

